import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  Get_One_Commission_Data_Action,
  Update_One_Commission_Data_Action,
} from '../Redux/Actions/Commission_Action';
import { Link, useParams } from 'react-router-dom';
import { TextField } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { UpdateClientAction } from '../Redux/Actions/UsersAction';
import { Notify } from '../Utility/Notify';

export const LeadUpdateCommissionpage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [commissionRate, setCommissionRate] = useState(0);
  const [commissionValue, setCommissionValue] = useState(0);

  const [companyCashbackRate, setCompanyCashbackRate] = useState(0);
  const [companyCashbackValue, setCompanyCashbackValue] = useState(0);

  const [salesRate, setSalesRate] = useState(0);
  const [salesValue, setSalesValue] = useState(0);

  const [marketerRate, setMarketerRate] = useState(0);
  const [marketerValue, setMarketerValue] = useState(0);

  const [teamLeaderRate, setTeamLeaderRate] = useState(0);
  const [teamLeaderValue, setTeamLeaderValue] = useState(0);

  const [managerRate, setManagerRate] = useState(0);
  const [managerValue, setManagerValue] = useState(0);

  const [vatRate, setVatRate] = useState(5);
  const [vatValue, setVatValue] = useState(0);

  const [finalBalance, setFinalBalance] = useState(0);

  // جلب بيانات الكوميشن من الـ API
  useEffect(() => {
    const getCommissionData = async () => {
      if (id) {
        await dispatch(Get_One_Commission_Data_Action(id));
      }
    };
    getCommissionData();
  }, [dispatch, id]);

  // جلب الريسبونس من الريدوكس
  const selectedCommissionResponse = useSelector((state) => state.AllCommissions.Add_Commission);

  const CommissionData = selectedCommissionResponse?.data || {};

  useEffect(() => {
    if (CommissionData && Object.keys(CommissionData).length > 0) {
      setCommissionRate(Number(CommissionData?.commissionRate || 0));
      setCommissionValue(Number(CommissionData?.commissionValue || 0));
      setCompanyCashbackRate(Number(CommissionData?.companyCashbackRate || 0));
      setCompanyCashbackValue(Number(CommissionData?.companyCashbackValue || 0));
      setSalesRate(Number(CommissionData?.salesRate || 0));
      setSalesValue(Number(CommissionData?.salesValue || 0));
      setMarketerRate(Number(CommissionData?.marketerRate || 0));
      setMarketerValue(Number(CommissionData?.marketerValue || 0));
      setTeamLeaderRate(Number(CommissionData?.teamLeaderRate || 0));
      setTeamLeaderValue(Number(CommissionData?.teamLeaderValue || 0));
      setManagerRate(Number(CommissionData?.managerRate || 0));
      setManagerValue(Number(CommissionData?.managerValue || 0));
      setVatRate(Number(CommissionData?.vatRate || 5));
      setVatValue(Number(CommissionData?.vatValue || 0));
      setFinalBalance(Number(CommissionData?.finalBalance || 0));
    }
  }, [CommissionData]);

  // console.log('CommissionData:', CommissionData);

  // console.log('commissionRate:', commissionRate);
  // console.log('commissionValue:', commissionValue);

  useEffect(() => {
    const price = parseFloat(CommissionData.unitprice) || 0;
    const calcFromPrice = (rate) => (price * parseFloat(rate || 0)) / 100;

    const commission = calcFromPrice(commissionRate);
    // const developerCashback = calcFromPrice(developerCashbackRate)
    const companyCashback = calcFromPrice(companyCashbackRate);

    const calcFromCommission = (rate) => (commission * parseFloat(rate || 0)) / 100;

    const sales = calcFromCommission(salesRate);
    const marketer = calcFromCommission(marketerRate);
    const teamLeader = calcFromCommission(teamLeaderRate);
    const manager = calcFromCommission(managerRate);

    const vat = (commission * vatRate) / 100;

    // const totalDeductions = commission + developerCashback + companyCashback + sales + marketer + teamLeader + manager + vat
    const netBalance = commission - companyCashback - sales - marketer - teamLeader - manager;

    setCommissionValue(commission);
    // setDeveloperCashbackValue(developerCashback)
    setCompanyCashbackValue(companyCashback);
    setSalesValue(sales);
    setMarketerValue(marketer);
    setTeamLeaderValue(teamLeader);
    setManagerValue(manager);
    setVatValue(vat);
    setFinalBalance(netBalance);
  }, [
    commissionRate,
    // developerCashbackRate,
    companyCashbackRate,
    salesRate,
    marketerRate,
    teamLeaderRate,
    managerRate,
    vatRate,
    CommissionData.unit_price,
  ]);

  const renderInput = (label, value, onChange) => (
    <>
      <div className="my-3">{label}</div>
      <div className="d-flex">
        <TextField label={label} type="number" value={value} onChange={onChange} className="w-75" />
        <div style={{ fontSize: '30px' }}>%</div>
      </div>
    </>
  );

  const renderResult = (label, value, color) => (
    <div className="my-4">
      <strong>{label}</strong>
      <div style={{ fontSize: '24px', color: color || 'black' }}>{value.toLocaleString()} AED</div>
      <hr />
    </div>
  );

  const [paymentDate, setPaymentDate] = useState('');
  const [Loadingupdate, setLoadingupdate] = useState(true);

  const confirmupdate = async () => {
    try {
      setLoadingupdate(true);
      await dispatch(
        Update_One_Commission_Data_Action(id, {
          lead: CommissionData?.lead?._id,
          project: CommissionData?.project?._id,
          developer: CommissionData?.project?.developer?._id,
          sales: CommissionData?.sales?.name,
          teamleader: CommissionData?.sales?.teamleader?.name,
          marketer: CommissionData?.chanel?.name,
          manager: CommissionData?.sales?.Manager?.name,
          commissionRate,
          commissionValue,
          companyCashbackRate,
          companyCashbackValue,
          salesRate,
          salesValue,
          marketerRate,
          marketerValue,
          teamLeaderRate,
          teamLeaderValue,
          managerRate,
          managerValue,
          vatRate,
          vatValue,
          finalBalance,
          paymentDate,
          unitprice: CommissionData.unitprice,
        }),
      );
      await dispatch(
        UpdateClientAction(id, {
          revenue: commissionValue,
          review: true,
        }),
      );

      Notify('success', '✅ Commission data Updated successfully!', 'success');

      // إعادة التوجيه بعد 1.5 ثانية
      setTimeout(() => {
        window.location.href = '#/LeadsForAccountant';
      }, 1500);
    } catch (error) {
      console.error(error);
      Notify('error', '❌ Something went wrong while Updating data.', 'error');
    } finally {
      setLoadingupdate(false);
    }
  };

  return (
    <Container className="startpage">
      <Link to={`/LeadsForAccountant`} style={{ textDecoration: 'none', color: '#0F7687' }}>
        <span style={{ fontWeight: 'bold' }}>Home</span>
      </Link>{' '}
      <KeyboardDoubleArrowRightIcon /> <span>Commission Preview</span>
      <KeyboardDoubleArrowRightIcon />
      <span>Update Lead Commission Data </span>
      <h4 className="my-4 d-flex justify-content-center flex-wrap w-100">
        Let's Go To Calculate Commission Again(Update)😍
      </h4>
      <hr />
      <div className="mb-3" style={{ fontSize: '20px' }}>
        <strong>Lead Name:</strong>{' '}
        {CommissionData?.lead?.name || <span className="text-muted">N/A</span>}
      </div>
      <div className="mb-3" style={{ fontSize: '20px' }}>
        <strong>Unit Price:</strong>{' '}
        <span style={{ color: 'royalblue' }}>
          {CommissionData?.unitprice ? (
            CommissionData.unitprice.toLocaleString() + ' AED'
          ) : (
            <span className="text-muted">N/A</span>
          )}
        </span>
      </div>
      <div className="mb-2" style={{ fontSize: '18px' }}>
        <strong>Developer:</strong>{' '}
        {CommissionData?.developer?.name || <span className="text-muted">N/A</span>}
      </div>
      <div className="mb-2" style={{ fontSize: '18px' }}>
        <strong>Project:</strong>{' '}
        {CommissionData?.project?.name || <span className="text-muted">N/A</span>}
      </div>
      <hr />
      {renderInput('Company Commission Rate %:', commissionRate, (e) =>
        setCommissionRate(e.target.value),
      )}
      {renderResult('Total Company Commission:', commissionValue, 'green')}
      {/* {renderInput("Cashback (Developer) Rate %:", developerCashbackRate, (e) => setDeveloperCashbackRate(e.target.value))}
      {renderResult("Total Cashback (Developer):", developerCashbackValue, "blue")} */}
      {renderInput('Cashback (Company) Rate %:', companyCashbackRate, (e) =>
        setCompanyCashbackRate(e.target.value),
      )}
      {renderResult('Total Cashback (Company):', companyCashbackValue, 'purple')}
      {renderInput(
        <>
          Sales Commission Rate % (from Company Commission):{' '}
          <span style={{ fontWeight: 'bold', color: '#007bff' }}>
            {CommissionData?.sales?.name}
          </span>
        </>,
        salesRate,
        (e) => setSalesRate(e.target.value),
      )}{' '}
      {renderResult('Sales Commission (from total company commission):', salesValue, '#ff9800')}
      {renderInput(
        <>
          Marketer Commission Rate % (from Company Commission):{' '}
          <span style={{ fontWeight: 'bold', color: '#28a745', fontSize: '16px' }}>
            {CommissionData?.chanel?.name}
          </span>
        </>,
        marketerRate,
        (e) => setMarketerRate(e.target.value),
      )}{' '}
      {renderResult('Marketer Commission:', marketerValue, '#00bcd4')}
      {renderInput(
        <>
          Team Leader Commission Rate % (from Company Commission):{' '}
          <span style={{ fontWeight: 'bold', color: '#28a745', fontSize: '16px' }}>
            {CommissionData?.sales?.teamleader?.name}
          </span>
        </>,
        teamLeaderRate,
        (e) => setTeamLeaderRate(e.target.value),
      )}{' '}
      {renderResult('Team Leader Commission:', teamLeaderValue, '#9c27b0')}
      {renderInput(
        <>
          Manager Commission Rate % (from Company Commission):{' '}
          <span style={{ fontWeight: 'bold', color: '#6610f2', fontSize: '16px' }}>
            {CommissionData?.sales?.Manager?.name}
          </span>
        </>,
        managerRate,
        (e) => setManagerRate(e.target.value),
      )}{' '}
      {renderResult('Manager Commission:', managerValue, '#607d8b')}
      {renderInput('VAT %:', vatRate, (e) => setVatRate(e.target.value))}
      {renderResult('VAT Value:', vatValue, '#f44336')}
      {/* Date of Payment */}
      <div className="mb-3">
        <label htmlFor="paymentDate" className="form-label">
          Date of Payment
        </label>
        <input
          type="date"
          className="form-control"
          id="paymentDate"
          value={paymentDate}
          onChange={(e) => setPaymentDate(e.target.value)}
        />
      </div>
      <div className="my-5">
        <h5>💰 Final Balance:</h5>
        <div style={{ fontSize: '28px', color: 'darkgreen' }}>
          {finalBalance.toLocaleString()} AED
        </div>

        <div>
          {/* Confirm Button */}
          <div onClick={confirmupdate} className="btn btn-primary w-100 my-4">
            Confirm Update
            <CheckIcon />
          </div>
        </div>
      </div>
      <div style={{ marginTop: '100px' }}></div>
    </Container>
  );
};
